"use client"

import { IconButton, Text } from "@/elements"
import { NovaWordmark } from "@/svg/NovaWordmark"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { FC } from "react"
import { SubscriptionPlan } from "../useSubscriptionCheckoutModal"
import { Benefits } from "./Benefits"
import { ProBadge } from "./ProBadge"
import { TrustedBy } from "./TrustedBy"
import { PlanRow } from "./PlanRow"

interface Props {
  selectedPlanId: string | null
  onSelectPlan: (planId: string) => void
  subscriptionPlans: SubscriptionPlan[]
  eligibleForFreeTrial: boolean
  singlePurchasePlans: SubscriptionPlan[]
  closeModal: () => void
}

export const StepOne: FC<Props> = ({
  subscriptionPlans,
  singlePurchasePlans,
  onSelectPlan,
  selectedPlanId,
  eligibleForFreeTrial,
  closeModal,
}) => {
  return (
    <div className="">
      <div className="grid w-full grid-cols-12 gap-2">
        <div className="col-span-12 sm:col-span-6">
          <div className="mb-6 flex flex-row items-center justify-between gap-3">
            <div className="flex flex-row items-center gap-3">
              <NovaWordmark width={82} height={21} />
              <ProBadge />
            </div>
            <IconButton Icon={XMarkIcon} onClick={closeModal} className="sm:hidden" />
          </div>
          <Text className="text-pro-gradient-dark mb-5 mt-5 sm:mb-0 sm:mt-0" variant="h6">
            Land the job that changes everything.
          </Text>
        </div>
        <div className="col-span-12 sm:col-span-6">
          <Benefits showFreeTrialTag={true} />
        </div>
      </div>

      <div className="my-8 flex flex-col gap-3 sm:mt-[38px]">
        {subscriptionPlans.map((plan, index) => {
          const selected = selectedPlanId === plan.priceId
          return (
            <PlanRow
              key={`sub-${index}`}
              plan={plan}
              selected={selected}
              onSelectPlan={onSelectPlan}
              selectedPlanId={selectedPlanId}
              eligibleForTrial={eligibleForFreeTrial}
            />
          )
        })}
        <Text variant="body2" className="text-center text-fg-2">
          OR
        </Text>

        {singlePurchasePlans.map((plan, index) => {
          const selected = selectedPlanId === plan.priceId
          return (
            <PlanRow
              eligibleForTrial={eligibleForFreeTrial}
              key={`sub-${index}`}
              plan={plan}
              selected={selected}
              onSelectPlan={onSelectPlan}
              selectedPlanId={selectedPlanId}
            />
          )
        })}
      </div>

      <TrustedBy />
    </div>
  )
}
